import { atomIcon } from './components/atoms/atomIcon';

export const themes = [
  'backgroundOne',
  'backgroundTwo',
  'backgroundThree',
  'backgroundFour',
  'backgroundFive',
  'backgroundSix',
  'backgroundSeven',
  'backgroundEight'
];

document.addEventListener('DOMContentLoaded', () => atomIcon());

if (document.body.id === 'basestyle') {
  let themeIndex = 0;
  let currentButtonState: 'enabled' | 'disabled' = 'enabled';
  let currentSiteType: 'GGEW' | 'GGEWNet' = 'GGEW';

  /**
   * Change state of components in the BaseStyle
   * @param e Keyboard event
   */
  const onKeydown = (e: KeyboardEvent) => {
    /** Toggle {@link themes} on keydown */
    if (e.code === 'KeyT') {
      const elements: HTMLElement[] = Array.from(
        document.querySelectorAll('.component')
      );

      const currentThemeElement: HTMLSpanElement =
        document.getElementById('currentTheme');

      themeIndex++;
      if (themeIndex > themes.length - 1) themeIndex = 0;

      elements.forEach((element) => {
        element.classList.remove(...themes);
        element.classList.add(themes[themeIndex]);
      });

      currentThemeElement.innerText = themes[themeIndex];
    }

    /** Toggle disable buttons */
    if (e.code === 'KeyD') {
      const elements: (
        | HTMLAnchorElement
        | HTMLButtonElement
        | HTMLInputElement
        | HTMLTextAreaElement
        | HTMLSelectElement
      )[] = Array.from(
        document.querySelectorAll('.button, input, select, textarea')
      );

      const currentButtonStateElement: HTMLSpanElement =
        document.getElementById('currentButtonState');

      currentButtonState =
        currentButtonState === 'enabled' ? 'disabled' : 'enabled';
      currentButtonStateElement.innerText = currentButtonState;

      elements.forEach((button) => {
        if (button.hasAttribute('disabled')) {
          button.removeAttribute('disabled');
        } else {
          button.setAttribute('disabled', '');
        }
      });
    }

    if (e.code === 'KeyC') {
      const siteType: HTMLHtmlElement = document.querySelector('html');
      const siteNames: Array<string> = ['page--ggew', 'page--ggewNet'];

      const currentClass = Array.from(siteType.classList).find((x) =>
        x.startsWith('page--')
      );
      let currentThemeIndex = siteNames.findIndex((x) => x === currentClass);

      currentThemeIndex++;
      if (currentThemeIndex > siteNames.length - 1) {
        currentThemeIndex = 0;
      }

      siteType.classList.remove(currentClass);
      siteType.classList.add(siteNames[currentThemeIndex]);

      const currentSiteTypeElement: HTMLSpanElement =
        document.getElementById('currentSiteType');

      currentSiteType = currentSiteType === 'GGEW' ? 'GGEWNet' : 'GGEW';
      currentSiteTypeElement.innerHTML = currentSiteType;
    }
  };

  document.addEventListener('keydown', onKeydown);
}
